if (!window.customElements.get('practitioners-section')) {
  class Practitioners extends HTMLElement {
    constructor() {
      super();
      this.paginationSelect = this.querySelector('[data-practitioners-pagination-select]');
      this.regionSelect = this.querySelector('[data-practitioners-region-select]');
      this.searchForm = this.querySelector('[data-practitioners-search-form]');
      this.searchInput = this.querySelector('[data-practitioners-search-input]');
    }

    connectedCallback() {
      this.paginationSelect.addEventListener('change', () => this.updatePagination());
      this.regionSelect.addEventListener('change', () => this.updateRegion());
      this.searchForm.addEventListener('submit', (event) => this.validateSearch(event));
      this.searchInput.addEventListener('blur', (event) => this.validateSearch(event));
    }

    updatePagination() {
      let url = new URL(window.location.href);

      if (window.location.href.indexOf('view') >= 0) {
        url.searchParams.set('view', this.paginationSelect.value);
      } else {
        url.searchParams.append('view', this.paginationSelect.value);
      }

      window.location.href = url;
    }

    updateRegion() {
      window.location.href = `${window.location.pathname.split('/tagged/')[0]}/tagged/${this.regionSelect.value}${window.location.search}`;
    }

    validateSearch(event) {
      if (this.searchInput.value !== '') { return; }
      event.preventDefault();
      window.location.href = this.searchInput.getAttribute('data-practitioners-blog-url');
    }
  }

  window.customElements.define('practitioners-section', Practitioners);
}
